// extracted by mini-css-extract-plugin
export var container = "_t0-0";
export var table = "_t0-2";
export var tableWrapper = "_t0-1";